/**
 * The session-state patch that takes a vehicle off the charging attempt.
 *
 * Used wherever the driver moves to the public card flow or goes back to
 * choose a different vehicle: "Pay by card instead" on the PIN step, and
 * "Continue with card" / "Select another vehicle" on the access result step.
 *
 * Every vehicle-derived billing rule is cleared, so a plate entered a moment
 * ago cannot leave a fleet or zero rate behind and let someone charge without
 * paying. `verified` is forced false and `paymentRequired` true for the same
 * reason. The unified `vehicle` object is replaced wholesale rather than
 * patched, so no stale field survives to be read downstream.
 */
export function clearedVehicleState() {
  return {
    // Legacy top-level fields.
    licensePlate: '',
    verifiedPlate: null,
    vehicleVerified: false,
    vehicleId: null,
    selectedVehicleId: null,
    selectedVehicle: null,
    billingMode: null,
    rateOverride: null,
    vehicle: {
      licensePlateRaw: null,
      licensePlateNormalized: null,
      vehicleId: null,
      verified: false,
      billingMode: null,
      rateOverride: null,
      paymentRequired: true,
      rateApplied: null,
      ownerName: null,
      ownerEmail: null,
    },
  };
}
